import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import { ElementType } from 'react';

import { facebookBlue, linkedInBlue, twitterBlue } from '@styles/colors';

type SocialOption = {
  title: string;
  url: string;
  color: string;
  Icon: ElementType;
};

export const socialShareOptions: SocialOption[] = [
  {
    title: 'Facebook',
    url: 'https://www.facebook.com/sharer/sharer.php?u=',
    Icon: FacebookIcon,
    color: facebookBlue,
  },
  {
    title: 'Twitter / X',
    url: 'https://twitter.com/intent/tweet?url=',
    Icon: TwitterIcon,
    color: twitterBlue,
  },
  {
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
    Icon: LinkedInIcon,
    color: linkedInBlue,
  },
];
